export default __webpack_public_path__ + "./images/eo.fd395372.png";